import t from 'modules/i18n/intl';
import React from 'react';
import { FormattedDate } from 'react-intl';
import { ExpiringDateSelectOption } from './types';

export function generateMonthList() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 2;
  const endYear = currentYear + 2;

  const monthList: Array<ExpiringDateSelectOption> = [{ label: t('mac.licenses.expiring.in') }];

  for (let year = startYear; year <= endYear; year += 1) {
    for (let month = 0; month < 12; month += 1) {
      monthList.push({
        label: <FormattedDate value={new Date(year, month)} year="numeric" month="short" />,
        value: new Date(year, month),
      });
    }
  }

  return monthList;
}
